<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <hm-table :id="$attrs['id']" :hover="false" :columns="`${7 + (created ? 1 : 0)}`" min-width="700px">
    <template slot="table-head">
      <div class="hm-table__th">{{ $t('table.transferredTransactionTable.chargePeriod') }}</div>
      <div class="hm-table__th">{{ $t('table.transferredTransactionTable.label') }}</div>
      <div v-if="created" class="hm-table__th">{{ $t('table.transferredTransactionTable.created') }}</div>
      <div class="hm-table__th">{{ $t('table.transferredTransactionTable.transferred') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferredTransactionTable.count') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferredTransactionTable.singleItemAmount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferredTransactionTable.totalAmount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferredTransactionTable.transferDirectionAndTarget') }}</div>
    </template>
    <template slot="default">
      <template v-for="trans in transactions">
        <template v-if="!isNil(trans.transaction)">
          <div v-if="!isEmpty(trans.transaction.chargePeriod)" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td">{{ trans.transaction.chargePeriod.startDate | toDate }} - {{ trans.transaction.chargePeriod.endDate | toDate }}</div>
          <div v-else :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td">{{ trans.transaction.businessDate | toDate }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td">{{ trans.transaction.label }}{{ additionalLabel(trans.transaction) }}</div>
          <div v-if="created" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td">{{ trans.transaction.creationDate | toLocalDateTime }} // {{ trans.transaction.userName }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td">{{ trans.dateTime | toLocalDateTime }} // {{ trans.user }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td text-right">{{ trans.transaction.itemCount }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td text-right">{{ trans.transaction.itemCount === 0 ? 0 : trans.transaction.amount / trans.transaction.itemCount | toCurrency }} {{ hotelSettings.details.currency }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td text-right">{{ trans.transaction.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
          <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans.transaction)}]" class="hm-table__td text-right">
            <div class="hm-table__td hm-table__td--icon">
              <span v-tooltip="transferTooltip(trans, trans.destination.parentId, trans.destination)" v-if="trans.direction === 'Out'" class="quick-action-button icon--red" @click="routeToTarget(trans.destination)">
                <icon icon="forward-2c" />
              </span>
              <span v-tooltip="transferTooltip(trans, trans.source.parentId, trans.source)" v-if="trans.direction === 'In'" class="quick-action-button icon--green" @click="routeToTarget(trans.source)">
                <icon icon="back-2c" />
              </span>
            </div>
          </div>
          <template v-for="childTrans in trans.transaction.childTransactions">
            <template v-if="childTrans.includedInParent === false">
              <div v-if="!isEmpty(trans.chargePeriod)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td">{{ childTrans.chargePeriod.startDate | toDate }} - {{ childTrans.chargePeriod.endDate | toDate }}</div>
              <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td">{{ childTrans.businessDate | toDate }}</div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td">{{ childTrans.label }}</div>
              <div v-if="created" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td"></div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td"></div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td text-right">{{ childTrans.itemCount }}</div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td text-right">{{ childTrans.itemCount === 0 ? 0 : childTrans.amount / childTrans.itemCount | toCurrency }} {{ hotelSettings.details.currency }}</div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td text-right">{{ childTrans.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
              <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans.transaction, childTrans)}]" class="hm-table__td text-right"></div>
            </template>
          </template>
        </template>
      </template>
    </template>
  </hm-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last } from 'lodash';

export default {
  name: 'TransferredTransactionTable',

  mixins: [HotelmeisterMixin],

  props: {
    parentId: {
      type: String,
      required: false,
      default: null,
    },
    transactions: {
      type: Array,
      required: true,
      default: () => [],
    },
    folios: {
      type: Array,
      required: false,
      default: () => [],
    },
    created: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
  },

  methods: {
    transferTooltip(trans, parentId, transfer) {
      let title = `${this.$t(`folio.transfer.${trans.direction}`, [this.$t(`folio.title.${parentId.type}`, [this.id2number(parentId.id)])])}`;

      if (!isEmpty(parentId) && parentId.id === this.parentId && !isEmpty(this.folios) && !isEmpty(transfer.folioNumber)) {
        const folio = this.folios.find(it => it.id === transfer.folioNumber);
        if (!isNil(folio) && !isEmpty(folio.name)) {
          title = `${this.$t(`folio.transfer.${trans.direction}`, [folio.name])}`;
        }
      }

      return {
        title: () => title,
        closeOnClickOutside: true,
        delay: 500,
        placement: 'top',
        trigger: 'hover',
        touch: false,
      };
    },
    routeToTarget(destination) {
      if (isNil(destination)) return;

      if (destination.parentId.type === 'RoomReservation') {
        this.$router.push({ name: 'reservationFolio', params: { reservationId: destination.parentId.id, folioId: destination.folioNumber } });
      }

      if (destination.parentId.type === 'GuestProfile') {
        this.$router.push({ name: 'guestFolio', params: { guestProfileId: destination.parentId.id, folioId: destination.folioNumber } });
      }
      // {"parentId":{"type":"RoomReservation","id":"hotel::4::res::503","additionalFields":null},"folioNumber":"66622ec4-2e26-47f4-89a9-39a0de8fe1af"}
    },
    additionalLabel(trans) {
      if (trans.code.type === 'RatePlan') {
        let ret = '';
        if (!isEmpty(trans.calculationDetails.roomNumber)) {
          ret += ` Zi. ${trans.calculationDetails.roomNumber}`;
        }
        if (!isEmpty(trans.calculationDetails.roomTypeId)) {
          ret += ` (${this.findHotelSettingById('roomTypes', trans.calculationDetails.roomTypeId).abbreviation})`;
        }
        if (!isEmpty(trans.reservationId)) {
          ret += `, Res #${this.id2number(trans.reservationId)}`;
        }
        ret = ret.trim();
        if (!isEmpty(ret)) {
          ret = ` // ${ret}`;
        }
        return ret;
      } else {
        return null;
      }
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    hasChildTrans(trans) {
      return isNil(trans.childTransactions) ? false : trans.childTransactions.filter(it => it.includedInParent === false).length > 0;
    },
    isLastChildTrans(trans, childTrans) {
      return isNil(trans.childTransactions) ? false : last(trans.childTransactions.filter(it => it.includedInParent === false)) === childTrans;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .icon {
    &--green {
      @include icon-color($mint);
    }
    &--red {
      @include icon-color($error);
    }
  }
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/TransferredTransactionTable.vue